import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    size: "A4"
  },
  container: {
    padding: "25px"
  },
  headerContainer: {
    display: "flex",
    flexDirection: "row",
    borderStyle: "solid",
    borderWidth: "1",
    borderRadius: "4",
    height: "100px"
  },
  headerLeft: {
    flex: 1,
    textAlign: "left",
    fontSize: "10"
  },
  TitleHeaderLeft: {
    textAlign: "center",
    fontSize: "20"
  },
  headerRight: {
    flex: 1,
    textAlign: "center",
    fontSize: "15"
  },
  headerRightPrincipal: {
    height: "90px"
  },
  headerLetter: {
    width: "40px",
    display: "flex",
    flexDirection: "column",
    backgroundColor: "black"
  },
  letter: {
    height: "30px",
    borderStyle: "solid",
    borderWidth: "1",
    fontWeight: "bold",
    textAlign: "center",
    color: "white",
    fontSize: "25"
  },
  clientContainer: {
    display: "flex",
    flexDirection: "row",
    borderStyle: "solid",
    borderWidth: "1",
    borderRadius: "4",
    height: "70px",
    marginTop: "2px"
  },
  clientLeft: {
    flex: 1,
    fontSize: "12"
  },
  clientRight: {
    flex: 1,
    fontSize: "12"
  },
  paymentsContainer: {
    display: "flex",
    flexDirection: "column",
    borderStyle: "solid",
    borderWidth: "1",
    borderRadius: "4",
    height: "450px",
    marginTop: "2px"
  },
  titlePaymentsContainer: {
    height: "15px",
    backgroundColor: "black",
    color: "white",
    fontSize: "8",
    fontWeight: "bold",
    flexDirection: "row"
  },
  detailTitle: {
    width: "445px",
    textAlign: "center",
    paddingTop: "3px"
  },
  totalTitle: {
    width: "100px",
    textAlign: "center",
    paddingTop: "3px"
  },
  footerContainer: {
    display: "flex",
    flexDirection: "row",
    marginTop: "2px",
    height: "150px"
  },
  leftFooter: {
    flex: 1,
    display: "flex",
    flexDirection: "column"
  },
  observations: {
    flex: 1,
    borderStyle: "solid",
    borderWidth: "1",
    borderRadius: "4",
    fontSize: "10",
    marginTop: "2px",
    flexDirection: "column",
    display: "flex"
  },
  titleObservations: {
    height: "15px",
    width: "100%",
    backgroundColor: "black",
    color: "white",
    fontSize: "8",
    fontWeight: "bold"
  },
  detailObservations: {
    fontSize: "8",
    width: "100%"
  },
  rightFooter: {
    flex: 1,
    borderStyle: "solid",
    borderWidth: "1",
    borderRadius: "4",
    flexDirection: "row"
  },
  titlesRightFooter: {
    flex: 2,
    textAlign: "right",
    fontSize: "14"
  },
  detailsRightFooter: {
    flex: 1,
    textAlign: "right",
    fontSize: "14"
  },
  payments: {
    fontSize: "10",
    flexDirection: "row"
  },
  paymentDetail: {
    width: "445px",
    textAlign: "left",
    paddingTop: "3px"
  },
  paymentTotal: {
    width: "83px",
    textAlign: "right",
    paddingTop: "3px"
  },
  enter: {
    color: "white"
  }
});

// Create Document Component
const PDFReceipt = ({ customerName, customerStreet, customerIva, customerCity, customerCuit, receiptNumber,
                        date, payments, debt, paid, balance, observations, customerState }) => (
  
  <Document>
    <Page style={styles.page}>
        <View style={styles.container}>
            <View style={styles.headerContainer}>
              <View style={styles.headerLeft}>
                <View style={styles.TitleHeaderLeft}>
                  <Text>VETERINARIA CAJEAO</Text>
                </View>
                <View style={styles.enter}><Text>Enter</Text></View>
                <Text>Razón social: Cajeao Pablo Manuel</Text>
                <Text>Domicilio comercial: Santa Fe 165 - Ticino, Córdoba</Text>
                <Text>Cond. frante al IVA: IVA RESPONSABLE INSCRIPTO</Text>
                <Text>Celular: 3535635614</Text>
              </View>
              <View style={styles.headerLetter}>
                <View style={styles.letter}><Text>X</Text></View>
              </View>
              <View style={styles.headerRight}>
                <View style={styles.headerRightPrincipal}>
                  <Text>Recibo</Text>
                  <Text>N°: {receiptNumber}</Text>
                  <Text>Fecha: {date}</Text>
                </View>
                <Text style={{fontSize: "7"}}>Documento no válido como factura</Text>
              </View>
            </View>
            <View style={styles.clientContainer}>
              <View style={styles.clientLeft}>
                <Text>C.U.I.T.: {customerCuit}</Text>
                <Text>Apellido y Nombre/Razón Social: {customerName}</Text>
                <Text>Domicilio: {customerStreet} - {customerCity}, {customerState}</Text>
                <Text>Cond. I.V.A.: {customerIva}</Text>
              </View>
            </View>
            <View style={styles.paymentsContainer}>
              <View style={styles.titlePaymentsContainer}>
                <View style={styles.detailTitle}>
                  <Text>DETALLE</Text>
                </View>
                <View style={styles.totalTitle}>
                  <Text>TOTAL</Text>
                </View>
              </View>
              <View style={styles.payments}>
                <View style={styles.paymentDetail}>
                  {payments && payments.map(payment => (
                    <Text key={payment.paymentIndex}>{payment.paymentMethod}</Text>
                  ))}
                </View>
                <View style={styles.paymentTotal}>
                  {payments && payments.map(payment => (
                    <Text key={payment.paymentIndex}>${parseFloat(payment.amount).toFixed(2)}</Text>
                  ))}
                </View>
              </View>
            </View>
            <View style={styles.footerContainer}>
              <View style={styles.leftFooter}>
                <View style={styles.observations}>
                  <View style={styles.titleObservations}>
                    <Text style={{paddingTop: "3px", paddingLeft: "3px"}}>OBSERVACIONES</Text>
                  </View>
                  <View style={styles.detailObservations}>
                    <Text>{observations}</Text>
                  </View>
                </View>
              </View>
              <View style={styles.rightFooter}>
                <View style={styles.titlesRightFooter}>
                  <Text>IMPORTE ADEUDADO: </Text>
                  <Text>IMPORTE ABONADO: </Text>
                  <Text>SALDO: </Text>
                </View>
                <View style={styles.detailsRightFooter}>
                  <Text>${parseFloat(debt).toFixed(2)}</Text>
                  <Text>${parseFloat(paid).toFixed(2)}</Text>
                  <Text>${parseFloat(balance).toFixed(2)}</Text>
                </View>
              </View>
            </View>
        </View>
    </Page>
  </Document>
);

export default PDFReceipt